import { isCordovaBuild } from 'lib/cordovaHelpers';

const parseUrl = () => {
    const regex = new RegExp(/(\.\w+)$/i);

    const toplevelUrl = window.location.origin.match(regex)?.map((parsedString) => parsedString.replace('.', ''));

    if (toplevelUrl?.length) {
        return toplevelUrl[0];
    }
    return null;
};

const sentryConfig = () => {
    const config = {
        SENTRY_DSN: 'https://12ba69deacdeafa05484119158a8e33f@o4506540738281472.ingest.sentry.io/4506541922582528',
        SENTRY_ENVIRONMENT: 'local',
    };
    const toplevelUrl = parseUrl();
    if (!toplevelUrl)
        return {
            ...config,
            SENTRY_ENVIRONMENT: 'no top level url',
        };
    if (isCordovaBuild)
        return {
            ...config,
            SENTRY_ENVIRONMENT: 'ios',
        };
    switch (toplevelUrl) {
        case 'work':
            return {
                ...config,
                SENTRY_ENVIRONMENT: 'staging',
            };

        case 'se':
            return {
                ...config,
                SENTRY_ENVIRONMENT: 'production',
            };

        default:
            return config;
    }
};

export default sentryConfig;
